export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD'
export const FRONTEND_DATE_FORMAT = 'MM/DD/YYYY'

export const FRONTEND_DATE_FORMAT_DATE_FNS = 'MM/dd/yyyy'
